// components/SmartAppDialog.tsx
import { Cross2Icon } from '@radix-ui/react-icons';
import { Dialog, Button } from '@radix-ui/themes';
import { useSmartAppDialog } from 'helpers/useSmartAppDialog';
import { AndroidIcon, AppleIcon, TennistalkerIcon } from './SocialIcons';

export const SmartAppDialog: React.FC = () => {
  const { isOpen, setIsOpen, deviceInfo } = useSmartAppDialog();

  // Don't render anything if there's no device info
  if (!deviceInfo) {
    return null;
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>Scarica l'app di TennisTalker</Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>
          Download the TennisTalker app for a better experience.
        </Dialog.Description>
        <div className='flex flex-col items-center justify-center gap-6'>
          <div className='flex gap-4'>
            <TennistalkerIcon />
          </div>
          <div className='flex'>
            <div className='flex flex-col justify-center gap-4 text-center'>
              <h5 className='text-lg font-bold'>Vivi l'esperienza completa con la nostra App!</h5>
              <p className='text-gray-11 text-sm'>
                Naviga tra giocatori, risultati, statistiche e molto altro con facilità.
              </p>
              <p className='mt-1 text-xl font-bold'>Gratis - su {deviceInfo.storeName}</p>
            </div>
          </div>

          <div className='mt-2 flex justify-end gap-3'>
            <Button size={'4'} asChild>
              <a href={deviceInfo.storeLink} target='_blank' rel='noopener noreferrer'>
                {deviceInfo.os === 'ios' ? <AppleIcon /> : <AndroidIcon />}
                <p className='ml-2'>Scarica</p>
              </a>
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};
